'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _prefix = require('../prefix');

var _prefix2 = _interopRequireDefault(_prefix);

var _pascalize = require('../utils/pascalize');

var _pascalize2 = _interopRequireDefault(_pascalize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Test if property is supported with vendor prefix.
exports['default'] = {
  supportedProperty: function supportedProperty(prop, style) {
    var pascalized = (0, _pascalize2['default'])(prop);
    if (_prefix2['default'].js + pascalized in style) return _prefix2['default'].css + prop;
    // Try webkit fallback.
    if (_prefix2['default'].js !== 'Webkit' && 'Webkit' + pascalized in style) return prop;
    return false;
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/css-vendor/lib/plugins/prefixed.js
// module id = 16
// module chunks = 0